module.exports = __webpack_public_path__ + "static/media/menudeo.5151f79c.png";